<script setup>
import { onMounted, ref, watch } from 'vue';
import { useCustomerStore } from '@/stores/customer';
import { useAccountDetailsStore } from '@/stores/account_details';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';

const customerStore = useCustomerStore();
const accountDetailsStore = useAccountDetailsStore();
const platformConfigurationStore = usePlatformConfigurationStore();

const betslip_changes = ref('always_ask');

const toggleBetslipChangesPreferences = (betslip_changes_option) => {
	const payload = { betslip_changes: 'always_ask' };
	if (betslip_changes.value !== betslip_changes_option) payload.betslip_changes = betslip_changes_option;

	accountDetailsStore.updateCustomerOdds(payload).then(() => {
		betslip_changes.value = payload.betslip_changes;
	});
};

watch(() => customerStore.getCustomer?.betslip_changes, (newVal) => {
	betslip_changes.value = newVal;
});

onMounted(() => {
	if (customerStore.isLoggedIn) {
		betslip_changes.value = customerStore.getCustomer?.betslip_changes ?? 'always_ask';
	} else {
		betslip_changes.value = 'always_ask';
	}
});
</script>

<template>
	<div class="row_settings" v-if="platformConfigurationStore.isAcceptAnyOddsEnabledOnBetslip && customerStore.isLoggedIn">
		<div class="betslip_settings">
			<label class="switch-label betslip_settings" @click="toggleBetslipChangesPreferences('accept_any_odds')">
				<p class="betslip_settings">{{ $t('account.account_preferences.accept_any_odds') }}</p>
				<input name="accept_any_odds" class="betslip_settings" :checked="betslip_changes == 'accept_any_odds'" type="checkbox">
				<span class="custom-switch betslip_settings"></span>
			</label>
		</div>
	</div>
</template>

<style scoped>
.row_settings {
	text-align: center;
	padding: 4px 0px 1px 10px;
}

.switch-label {
	display: flex;
	align-items: center;
	font-size: 13px;
	cursor: pointer;
	justify-content: space-between;
}

.custom-switch {
	width: 34px;
	height: 20px;
	background: var(--off-gray);
	border-radius: 20px;
	position: relative;
	margin-right: 10px;
	transition: all 0.3s;
}

html[dir="rtl"] .custom-switch {
	margin-right: unset;
	margin-left: 10px;
}

.custom-switch:before {
	content: '';
	position: absolute;
	width: 14px;
	height: 14px;
	background: var(--white);
	border-radius: 50%;
	top: 3px;
	left: 3px;
	transition: all 0.3s;
}

input[type='checkbox']:checked + .custom-switch {
	background: var(--primary);
}

input[type='checkbox']:checked + .custom-switch:before {
	transform: translateX(14px);
}

.betslip_settings {
	color: var(--primary);
}
</style>
